<app-top-bar-navigation [showBackButton]="true" title="Sleep Science Research" (backBtnClicked)="back()" />
<app-opt-info [optInState]="sleeperStudyState$ | async" [selectedSleeper]="selectedSleeper" />
<div siqGrid class="px-24 py-32">
  <app-learn-more class="w-100-p mt-48"/>
</div>
